/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PccE2eFixtureResetDocumentsByRelationTypeRequest
 */
export interface PccE2eFixtureResetDocumentsByRelationTypeRequest {
    /**
     *
     * @type {string}
     * @memberof PccE2eFixtureResetDocumentsByRelationTypeRequest
     */
    mode: PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum;
    /**
     *
     * @type {string}
     * @memberof PccE2eFixtureResetDocumentsByRelationTypeRequest
     */
    relation_type: PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum;
}


/**
 * @export
 */
export const PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum = {
    Documents: 'documents'
} as const;
export type PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum = typeof PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum[keyof typeof PccE2eFixtureResetDocumentsByRelationTypeRequestModeEnum];

/**
 * @export
 */
export const PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum = {
    Document: 'screener_document',
    AdditionalDocument: 'screener_additional_document',
    GeneratedDocument: 'screener_generated_document'
} as const;
export type PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum = typeof PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum[keyof typeof PccE2eFixtureResetDocumentsByRelationTypeRequestRelationTypeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetDocumentsByRelationTypeRequest interface.
 */
export function instanceOfPccE2eFixtureResetDocumentsByRelationTypeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mode" in value;
    isInstance = isInstance && "relation_type" in value;

    return isInstance;
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSON(json: any): PccE2eFixtureResetDocumentsByRelationTypeRequest {
    return PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetDocumentsByRelationTypeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'mode': json['mode'],
        'relation_type': json['relation_type'],
    };
}

export function PccE2eFixtureResetDocumentsByRelationTypeRequestToJSON(value?: PccE2eFixtureResetDocumentsByRelationTypeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'mode': value.mode,
        'relation_type': value.relation_type,
    };
}
